export default "__VITE_ASSET__373f55aa__"